import React, { forwardRef } from 'react';
import MuiSelect from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import makeStyles from '@mui/styles/makeStyles';

const Select = forwardRef(
  (
    {
      name,
      value,
      label,
      description,
      values,
      labels,
      itemStyles,
      selectedStyle,
      onChange,
      disabled,
      disabledWhenFilled,
      'data-test': dataTest,
      ...props
    },
    ref
  ) => {
    const useFormControlStyles = makeStyles({
      root: {
        width: '100%'
      }
    });

    const useStyles = makeStyles(theme => ({
      select: {
        ...(theme.isDark ? {} : { backgroundColor: 'white' })
      },
      disabled: {
        backgroundColor: 'transparent',
        ...(disabledWhenFilled ? { color: theme.palette.primary.main } : '')
      }
    }));

    const formControlClasses = useFormControlStyles();
    const classes = useStyles();

    return (
      <FormControl classes={formControlClasses}>
        <InputLabel>{label}</InputLabel>
        <MuiSelect
          inputRef={ref}
          classes={classes}
          name={name}
          size="small"
          label={label}
          value={value || ''}
          onChange={onChange}
          disabled={disabled || disabledWhenFilled}
          // add the 'data-test' attribute, falling back to the name by default
          SelectDisplayProps={{ ...(dataTest || name ? { 'data-test': dataTest || name } : {}) }}
          // add the 'select-popover' class for e2e tests
          MenuProps={{ PopoverClasses: { root: 'select-popover' } }}
          sx={selectedStyle}
          {...props}
        >
          {values.map((value, i) => {
            let val = value;
            let disabled = false;
            // if the value is an array
            if (Array.isArray(value)) {
              // get the value and the 'disabled' flag from the array
              [val, disabled] = value;
            }
            const itemStyle = itemStyles && itemStyles[i] ? itemStyles[i] : {};
            return (
              <MenuItem value={val} key={`val_${i}`} disabled={disabled} sx={itemStyle}>
                {labels[i]}
              </MenuItem>
            );
          })}
        </MuiSelect>
        <FormHelperText {...props}>{description}</FormHelperText>
      </FormControl>
    );
  }
);

export default Select;
